import { useEffect, useState } from "react";
import HttpAPICall from "../../../services/HttpAPICall";
import { useSelector } from "react-redux";
import { BACKOFFICE_BASE_URL } from "../../../services/TapApiUrls";
import { DisplayListPagination } from "../../../components/TapUi";
import Loader from "../../../components/ui/Loader/Loader";
import ApplicationLayout from "../../../layouts/ApplicationLayout";
import TapIcon from "../../../services/TapIcon";
import { Helmet } from "react-helmet";
import HorizontalCard from "../../includes/ui/HorizontalCard";
import { Collapse } from "bootstrap";

const AssetCounterLogMeterList = ({ history }) => {
    const assetCounterLogUrl    =       BACKOFFICE_BASE_URL + '/model'
    const access_token          =       useSelector(state => state.auth.access_token);
    
    const [listingLoading, setListingLoading]                       = useState(false);
    const [assetCounterLogListing, setAssetCounterLoglListing]      = useState([]);
    const [listingMeta, setListingMeta]                             = useState(null);

    useEffect(() => {
        loadListingTblData(1);
    }, []);

    const loadListingTblData = (page = 1) => {
        setListingLoading(true);
        const params = { page: page, per_page: 100 };
        HttpAPICall.withAthorization('GET', assetCounterLogUrl + '/list', access_token, params, {}, (resp) => {
            const respData = resp.data;
            setAssetCounterLoglListing(respData.data);
            setListingMeta({
                from: respData.from,
                to: respData.to,
                total: respData.total,
                last_page: respData.last_page,
                per_page: respData.per_page,
                current_page: respData.current_page
            });
        }).then(() => setListingLoading(false));
    };

    const handleClose = () => { history.push({ pathname: `/new_group_list` }); }

    const counterlogCardHandler = () => {
        new Collapse(document.getElementById('counterlogCard'));
        if (document.getElementById('pageTbl')) {
            document.getElementById('pageTbl').scroll({ top: 0, behavior: 'smooth' });
        }}
    return (
        <>
            <ApplicationLayout>
                <Helmet><title>Counterlog Listing</title></Helmet>
                <div id="counterlogCard" className="collapse pr-1 mt-1" aria-expanded="true" >
                    <HorizontalCard />
                </div>
                <div style={{ overflow: "hidden" }}>
                    <div className="page_title row m0">
                        <div className="bg-white row m0 text-decoration-none d-flex align-items-center">
                            <div className="col-sm-5 py-2">
                                <h5 className="fs-6 m-0">Counterlog List</h5>
                            </div>
                            <div className='col-sm-2 text-center align-self-start'>
                                <button type="button" className="btn btn-primary btn-sm" role="button" onClick={counterlogCardHandler}> Counterlog Card</button>
                            </div>
                            <div className='col-sm-5 text-end my-2'>
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={handleClose}  >
                                    <TapIcon.imageIcon icon={TapIcon.CloseIcon} className="img-fluid" alt="item-close" />
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="container-fluid pl5">
                        <div className="page_containt row">
                            <div className='pageTbl'>
                                <table className="table table-bordered table-fixed bg-white table-sm">
                                    <thead className="table-secondary">
                                        <tr className='text-center'>
                                            <th scope="col" style={{ width: "5%" }}>S.No</th>
                                            <th scope="col" style={{ width: "25%" }}>Asset</th>
                                            <th scope="col" style={{ width: "20%" }}>Prev Meters</th>
                                            <th scope="col" className="text-center" style={{ width: "20%" }}>New Meters</th>
                                            <th scope="col" className="text-center" style={{ width: "15%" }}>Changes On</th>
                                            <th scope="col" className="text-center" style={{ width: "15%" }}>Changes By</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {listingLoading
                                            ? (<tr><td colSpan="5"><Loader /></td></tr>)
                                            : (assetCounterLogListing && assetCounterLogListing.length > 0
                                                ? (assetCounterLogListing.map((item, index) => (
                                                    <tr key={index}>
                                                        <td className='text-center'>{listingMeta ? listingMeta.from + index : index}</td>
                                                        <td>{item.model ? item.model : "-"}</td>
                                                        <td>{item.manufacturer ? item.manufacturer.manufacturer : "-"}</td>
                                                        <td>{item.description ? item.description : "-"}</td>
                                                        <td>{item.description ? item.description : "-"}</td>
                                                        <td>{item.description ? item.description : "-"}</td>
                                                    </tr>
                                                )))
                                                : (<tr><td colSpan="5" className="text-center">No Records</td></tr>))
                                        }
                                    </tbody>
                                </table>
                                <DisplayListPagination
                                    meta={listingMeta}
                                    onPageChange={(e) => loadListingTblData(e.selected + 1)}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </ApplicationLayout>

        </>
    );
};

export default AssetCounterLogMeterList;
